import { render } from "./TheMenu.vue?vue&type=template&id=2014e2dd&scoped=true&ts=true"
import script from "./TheMenu.vue?vue&type=script&lang=ts"
export * from "./TheMenu.vue?vue&type=script&lang=ts"

import "./TheMenu.vue?vue&type=style&index=0&id=2014e2dd&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2014e2dd"]])

export default __exports__